import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['number'];
  static values = {
    duration: { type: Number, default: 1500 },
    start: { type: Number, default: 0 },
    threshold: { type: Number, default: 0.3 }
  };

  connect() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.numberData = this.numberTargets.map((el) => {
      const match = el.textContent.trim().match(/^(\d+(?:\.\d+)?)(.*)$/);
      const target = match ? parseFloat(match[1]) : 0;
      const suffix = match ? match[2] : '';
      el.textContent = `${this.startValue}${suffix}`;
      return { el, target, suffix };
    });

    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.animate();
          this.observer.disconnect();
          this.observer = null;
          break;
        }
      }
    }, { threshold: this.thresholdValue });
    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer?.disconnect();
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  animate() {
    const start = performance.now();
    const tick = (now) => {
      const elapsed = now - start;
      const t = Math.min(elapsed / this.durationValue, 1);
      const eased = 1 - Math.pow(1 - t, 3);

      for (const { el, target, suffix } of this.numberData) {
        const value = this.startValue + (target - this.startValue) * eased;
        el.textContent = `${Math.round(value)}${suffix}`;
      }

      if (t < 1) {
        this.rafId = requestAnimationFrame(tick);
      } else {
        this.rafId = null;
      }
    };
    this.rafId = requestAnimationFrame(tick);
  }
}
